import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Row } from 'antd';
import BenefitsTitleIcon from 'assets/images/benefits/benefits-title-icon.svg';
import { StyledTitle } from 'components/StyledTitle';

const StyledRow = styled(Row)`
  margin-top: 16px;
`;

function BenefitTitle() {
  const { t } = useTranslation();
  return (
    <StyledRow>
      <img src={BenefitsTitleIcon} alt="benefits-header-icon" />
      <StyledTitle level={2} margin="0 0 0 10px">
        {t('benefits.title')}
      </StyledTitle>
    </StyledRow>
  );
}

export default BenefitTitle;
